import { render, staticRenderFns } from "./FluxoProtesto.vue?vue&type=template&id=77e4868c"
import script from "./FluxoProtesto.vue?vue&type=script&lang=js"
export * from "./FluxoProtesto.vue?vue&type=script&lang=js"
import style0 from "./FluxoProtesto.vue?vue&type=style&index=0&id=77e4868c&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77e4868c')) {
      api.createRecord('77e4868c', component.options)
    } else {
      api.reload('77e4868c', component.options)
    }
    module.hot.accept("./FluxoProtesto.vue?vue&type=template&id=77e4868c", function () {
      api.rerender('77e4868c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FluxoProtesto.vue"
export default component.exports